(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('[data-accordion-trigger]').click(function () {
		$(this).parent().toggleClass('open');
	});
})();
